import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5707%3A5672
 *
 * @param {SvgIconProps} props - svg props
 */
export const UpIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M5.86198 10.6912C5.56932 10.4013 5.56531 9.92953 5.853 9.63465L11.4639 3.88357C11.7583 3.58187 12.2433 3.5819 12.5376 3.88364L18.147 9.63465C18.4346 9.92954 18.4306 10.4012 18.1379 10.6911L17.3474 11.4743C17.054 11.765 16.5809 11.7638 16.289 11.4717L12.9523 8.13278V19.25C12.9523 19.6642 12.6165 20 12.2023 20H11.7975C11.3833 20 11.0475 19.6642 11.0475 19.25V8.13278L7.71083 11.4717C7.41893 11.7638 6.94583 11.765 6.65247 11.4743L5.86198 10.6912Z' fill={color}/>
        </SvgIcon>
    )
}

export default UpIcon
